import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {CopilotConversationDto, CreateCopilotConversationBody, UpdateCopilotConversationBody} from './type'

class CopilotConversationServiceProvider extends ApiService {
  async getAll(): Promise<CopilotConversationDto[]> {
    return this.get<CopilotConversationDto[]>(`/copilot/conversation`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getById(conversationId: string): Promise<CopilotConversationDto> {
    return this.get<CopilotConversationDto>(`/copilot/conversation/${conversationId}`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async create(body: CreateCopilotConversationBody): Promise<CopilotConversationDto> {
    return this.post<CopilotConversationDto>(`/copilot/conversation`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async update(body: UpdateCopilotConversationBody, conversationId: string): Promise<CopilotConversationDto> {
    return this.patch<CopilotConversationDto>(`/copilot/conversation/${conversationId}`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async destroy(conversationId: string): Promise<void> {
    return this.delete<void>(`/copilot/conversation/${conversationId}`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const CopilotConversationService = new CopilotConversationServiceProvider()
